module.exports = __webpack_public_path__ + "img/list-check-box-on.899a5861.svg";